/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { useApp } from "../../AppContext";

const AuthNavbar = () => {
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("i18nextLng");
  const { config } = useApp();

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-simbalotto-green opacity-9">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <a className="navbar-brand" href="#">
                {config && (
                  <img
                    className="img-fluid w-100"
                    src={config?.app_logo}
                    alt={
                      config?.app_name ||
                      `${process.env.REACT_APP_SITE_NAME} Logo`
                    }
                  />
                )}
              </a>
            </div>

            <div className="col-6 justify-content-end d-flex">
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarToggle"
                aria-controls="navbarToggle"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
          <div
            className="collapse navbar-collapse bg-simbalotto-green opacity-9"
            id="navbarToggle"
          >
            <div className="navbar-collapse-header d-md-none">
              <div className="row">
                <div className="col-6">
                  <a className="navbar-brand" href="#">
                    {config && (
                      <img
                        src={config?.app_logo}
                        alt={
                          config?.app_name ||
                          `${process.env.REACT_APP_SITE_NAME} Logo`
                        }
                        width="100%"
                        height="100%"
                      />
                    )}
                  </a>
                </div>
                <div className="col-6 collapse-close">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarToggle"
                    aria-controls="navbarToggle"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span />
                    <span />
                  </button>
                </div>
              </div>
            </div>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className="nav-link active text-dark"
                  aria-current="page"
                  href={`https://${process.env.REACT_APP_SITE_URL}${
                    selectedLanguage === "en" ? "" : `/${selectedLanguage}`
                  }`}
                >
                  {t("navbar.home")}
                </a>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link text-dark"
                  href={`https://${process.env.REACT_APP_SITE_URL}${
                    selectedLanguage === "en" ? "" : `/${selectedLanguage}`
                  }/faq/`}
                >
                  {t("navbar.faq")}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default AuthNavbar;
